import * as React from "react"
import { graphql } from "gatsby"
import { BlogIndexTemplate } from "../pages/blog"
export { Head } from "../pages/blog"

const TagRoute = (props) => {
  const posts = props.data.allMarkdownRemark.edges
    .concat(props.data.allMdx.edges)
    .map((e) => e.node)
    .sort((a, b) => -a.frontmatter.date.localeCompare(b.frontmatter.date))

  return <BlogIndexTemplate posts={posts} tags={[props.pageContext.tag]} />
}

export default TagRoute

export const tagPageQuery = graphql`
  query TagPage($tag: String) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 1000
      sort: { frontmatter: { date: DESC } }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            tags
            templateKey
            date(formatString: "YYYY-MM-DD")
            image {
              childImageSharp {
                gatsbyImageData(quality: 100, width: 768, height: 576)
              }
            }
            previewImage {
              childImageSharp {
                gatsbyImageData(quality: 100, width: 768, height: 576)
              }
            }
          }
        }
      }
    }
    allMdx(
      sort: { frontmatter: { date: DESC } }
      filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            tags
            templateKey
            date(formatString: "YYYY-MM-DD")
            image {
              childImageSharp {
                gatsbyImageData(quality: 100, width: 768, height: 576)
              }
            }
            previewImage {
              childImageSharp {
                gatsbyImageData(quality: 100, width: 768, height: 576)
              }
            }
          }
        }
      }
    }
  }
`
